// extracted by mini-css-extract-plugin
export default {"root":"o7w8sWb5JwobUbnevGr9"};